<template>
	<div class="background">
		<div class="container">
			<br />
			<br />
			<br />
			<div class="registerComponent shadow p-4">
				<h1 class="title">
					We're Super Excited To <strong>Create a New Account!</strong>
				</h1>
				<br />
				<!-- Alert Msg -->
				<div class="alert alert-info  text-left">
					<i class="fas mr-2 fx-3 fa-info-circle"></i>Your not allowed to change
					your email again!
				</div>
				<!-- alert message -->
				<div class="alert-message errMsg red alert none text-white">
					<p>
						{{ err }}
					</p>
				</div>
				<br />
				<div class="row justify-content-center">
					<div class="col-md-6">
						<input
							type="text"
							v-model="name"
							placeholder="Enter Your Name"
							class="form-control name"
							name="name"
						/>
						<br />
						<input
							type="email"
							v-model="email"
							placeholder="Enter Your Email"
							class="form-control email"
							name="email"
						/>
						<br />
						<input
							type="text"
							v-model="phone"
							placeholder="Enter Your phone"
							class="form-control phone"
							name="phone"
						/>
						<br />
						<input
							type="text"
							v-model="address"
							placeholder="Enter Your address"
							class="form-control address"
							name="address"
						/>
						<br />
						<input
							type="text"
							v-model="zipCode"
							placeholder="Enter Your zip code"
							class="form-control zipCode"
							name="zip code"
						/>
						<br />
					</div>
					<div class="col-md-6">
						<!-- <br /> -->
						<input
							type="text"
							v-model="city"
							placeholder="Enter Your city"
							class="form-control city"
							name="city"
						/>
						<br />
						<!-- <input type="text"  placeholder='Enter Your country' class="form-control" name="country"> -->
						<select
							v-model="country"
							name="country"
							class="form-control country"
						>
							<option value="Select your country" disabled
								>Select Your country</option
							>
							<option value="Afghanistan">Afghanistan</option>
							<option value="Åland Islands">Åland Islands</option>
							<option value="Albania">Albania</option>
							<option value="Algeria">Algeria</option>
							<option value="American Samoa">American Samoa</option>
							<option value="Andorra">Andorra</option>
							<option value="Angola">Angola</option>
							<option value="Anguilla">Anguilla</option>
							<option value="Antarctica">Antarctica</option>
							<option value="Antigua and Barbuda">Antigua and Barbuda</option>
							<option value="Argentina">Argentina</option>
							<option value="Armenia">Armenia</option>
							<option value="Aruba">Aruba</option>
							<option value="Australia">Australia</option>
							<option value="Austria">Austria</option>
							<option value="Azerbaijan">Azerbaijan</option>
							<option value="Bahamas">Bahamas</option>
							<option value="Bahrain">Bahrain</option>
							<option value="Bangladesh">Bangladesh</option>
							<option value="Barbados">Barbados</option>
							<option value="Belarus">Belarus</option>
							<option value="Belgium">Belgium</option>
							<option value="Belize">Belize</option>
							<option value="Benin">Benin</option>
							<option value="Bermuda">Bermuda</option>
							<option value="Bhutan">Bhutan</option>
							<option value="Bolivia">Bolivia</option>
							<option value="Bosnia and Herzegovina"
								>Bosnia and Herzegovina</option
							>
							<option value="Botswana">Botswana</option>
							<option value="Bouvet Island">Bouvet Island</option>
							<option value="Brazil">Brazil</option>
							<option value="British Indian Ocean Territory"
								>British Indian Ocean Territory</option
							>
							<option value="Brunei Darussalam">Brunei Darussalam</option>
							<option value="Bulgaria">Bulgaria</option>
							<option value="Burkina Faso">Burkina Faso</option>
							<option value="Burundi">Burundi</option>
							<option value="Cambodia">Cambodia</option>
							<option value="Cameroon">Cameroon</option>
							<option value="Canada">Canada</option>
							<option value="Cape Verde">Cape Verde</option>
							<option value="Cayman Islands">Cayman Islands</option>
							<option value="Central African Republic"
								>Central African Republic</option
							>
							<option value="Chad">Chad</option>
							<option value="Chile">Chile</option>
							<option value="China">China</option>
							<option value="Christmas Island">Christmas Island</option>
							<option value="Cocos (Keeling) Islands"
								>Cocos (Keeling) Islands</option
							>
							<option value="Colombia">Colombia</option>
							<option value="Comoros">Comoros</option>
							<option value="Congo">Congo</option>
							<option value="Congo, The Democratic Republic of The"
								>Congo, The Democratic Republic of The</option
							>
							<option value="Cook Islands">Cook Islands</option>
							<option value="Costa Rica">Costa Rica</option>
							<option value="Cote D'ivoire">Cote D'ivoire</option>
							<option value="Croatia">Croatia</option>
							<option value="Cuba">Cuba</option>
							<option value="Cyprus">Cyprus</option>
							<option value="Czech Republic">Czech Republic</option>
							<option value="Denmark">Denmark</option>
							<option value="Djibouti">Djibouti</option>
							<option value="Dominica">Dominica</option>
							<option value="Dominican Republic">Dominican Republic</option>
							<option value="Ecuador">Ecuador</option>
							<option value="Egypt">Egypt</option>
							<option value="El Salvador">El Salvador</option>
							<option value="Equatorial Guinea">Equatorial Guinea</option>
							<option value="Eritrea">Eritrea</option>
							<option value="Estonia">Estonia</option>
							<option value="Ethiopia">Ethiopia</option>
							<option value="Falkland Islands (Malvinas)"
								>Falkland Islands (Malvinas)</option
							>
							<option value="Faroe Islands">Faroe Islands</option>
							<option value="Fiji">Fiji</option>
							<option value="Finland">Finland</option>
							<option value="France">France</option>
							<option value="French Guiana">French Guiana</option>
							<option value="French Polynesia">French Polynesia</option>
							<option value="French Southern Territories"
								>French Southern Territories</option
							>
							<option value="Gabon">Gabon</option>
							<option value="Gambia">Gambia</option>
							<option value="Georgia">Georgia</option>
							<option value="Germany">Germany</option>
							<option value="Ghana">Ghana</option>
							<option value="Gibraltar">Gibraltar</option>
							<option value="Greece">Greece</option>
							<option value="Greenland">Greenland</option>
							<option value="Grenada">Grenada</option>
							<option value="Guadeloupe">Guadeloupe</option>
							<option value="Guam">Guam</option>
							<option value="Guatemala">Guatemala</option>
							<option value="Guernsey">Guernsey</option>
							<option value="Guinea">Guinea</option>
							<option value="Guinea-bissau">Guinea-bissau</option>
							<option value="Guyana">Guyana</option>
							<option value="Haiti">Haiti</option>
							<option value="Heard Island and Mcdonald Islands"
								>Heard Island and Mcdonald Islands</option
							>
							<option value="Holy See (Vatican City State)"
								>Holy See (Vatican City State)</option
							>
							<option value="Honduras">Honduras</option>
							<option value="Hong Kong">Hong Kong</option>
							<option value="Hungary">Hungary</option>
							<option value="Iceland">Iceland</option>
							<option value="India">India</option>
							<option value="Indonesia">Indonesia</option>
							<option value="Iran, Islamic Republic of"
								>Iran, Islamic Republic of</option
							>
							<option value="Iraq">Iraq</option>
							<option value="Ireland">Ireland</option>
							<option value="Isle of Man">Isle of Man</option>
							<option value="Israel">Israel</option>
							<option value="Italy">Italy</option>
							<option value="Jamaica">Jamaica</option>
							<option value="Japan">Japan</option>
							<option value="Jersey">Jersey</option>
							<option value="Jordan">Jordan</option>
							<option value="Kazakhstan">Kazakhstan</option>
							<option value="Kenya">Kenya</option>
							<option value="Kiribati">Kiribati</option>
							<option value="Korea, Democratic People's Republic of"
								>Korea, Democratic People's Republic of</option
							>
							<option value="Korea, Republic of">Korea, Republic of</option>
							<option value="Kuwait">Kuwait</option>
							<option value="Kyrgyzstan">Kyrgyzstan</option>
							<option value="Lao People's Democratic Republic"
								>Lao People's Democratic Republic</option
							>
							<option value="Latvia">Latvia</option>
							<option value="Lebanon">Lebanon</option>
							<option value="Lesotho">Lesotho</option>
							<option value="Liberia">Liberia</option>
							<option value="Libyan Arab Jamahiriya"
								>Libyan Arab Jamahiriya</option
							>
							<option value="Liechtenstein">Liechtenstein</option>
							<option value="Lithuania">Lithuania</option>
							<option value="Luxembourg">Luxembourg</option>
							<option value="Macao">Macao</option>
							<option value="Macedonia, The Former Yugoslav Republic of"
								>Macedonia, The Former Yugoslav Republic of</option
							>
							<option value="Madagascar">Madagascar</option>
							<option value="Malawi">Malawi</option>
							<option value="Malaysia">Malaysia</option>
							<option value="Maldives">Maldives</option>
							<option value="Mali">Mali</option>
							<option value="Malta">Malta</option>
							<option value="Marshall Islands">Marshall Islands</option>
							<option value="Martinique">Martinique</option>
							<option value="Mauritania">Mauritania</option>
							<option value="Mauritius">Mauritius</option>
							<option value="Mayotte">Mayotte</option>
							<option value="Mexico">Mexico</option>
							<option value="Micronesia, Federated States of"
								>Micronesia, Federated States of</option
							>
							<option value="Moldova, Republic of">Moldova, Republic of</option>
							<option value="Monaco">Monaco</option>
							<option value="Mongolia">Mongolia</option>
							<option value="Montenegro">Montenegro</option>
							<option value="Montserrat">Montserrat</option>
							<option value="Morocco">Morocco</option>
							<option value="Mozambique">Mozambique</option>
							<option value="Myanmar">Myanmar</option>
							<option value="Namibia">Namibia</option>
							<option value="Nauru">Nauru</option>
							<option value="Nepal">Nepal</option>
							<option value="Netherlands">Netherlands</option>
							<option value="Netherlands Antilles">Netherlands Antilles</option>
							<option value="New Caledonia">New Caledonia</option>
							<option value="New Zealand">New Zealand</option>
							<option value="Nicaragua">Nicaragua</option>
							<option value="Niger">Niger</option>
							<option value="Nigeria">Nigeria</option>
							<option value="Niue">Niue</option>
							<option value="Norfolk Island">Norfolk Island</option>
							<option value="Northern Mariana Islands"
								>Northern Mariana Islands</option
							>
							<option value="Norway">Norway</option>
							<option value="Oman">Oman</option>
							<option value="Pakistan">Pakistan</option>
							<option value="Palau">Palau</option>
							<option value="Palestinian Territory, Occupied"
								>Palestinian Territory, Occupied</option
							>
							<option value="Panama">Panama</option>
							<option value="Papua New Guinea">Papua New Guinea</option>
							<option value="Paraguay">Paraguay</option>
							<option value="Peru">Peru</option>
							<option value="Philippines">Philippines</option>
							<option value="Pitcairn">Pitcairn</option>
							<option value="Poland">Poland</option>
							<option value="Portugal">Portugal</option>
							<option value="Puerto Rico">Puerto Rico</option>
							<option value="Qatar">Qatar</option>
							<option value="Reunion">Reunion</option>
							<option value="Romania">Romania</option>
							<option value="Russian Federation">Russian Federation</option>
							<option value="Rwanda">Rwanda</option>
							<option value="Saint Helena">Saint Helena</option>
							<option value="Saint Kitts and Nevis"
								>Saint Kitts and Nevis</option
							>
							<option value="Saint Lucia">Saint Lucia</option>
							<option value="Saint Pierre and Miquelon"
								>Saint Pierre and Miquelon</option
							>
							<option value="Saint Vincent and The Grenadines"
								>Saint Vincent and The Grenadines</option
							>
							<option value="Samoa">Samoa</option>
							<option value="San Marino">San Marino</option>
							<option value="Sao Tome and Principe"
								>Sao Tome and Principe</option
							>
							<option value="Saudi Arabia">Saudi Arabia</option>
							<option value="Senegal">Senegal</option>
							<option value="Serbia">Serbia</option>
							<option value="Seychelles">Seychelles</option>
							<option value="Sierra Leone">Sierra Leone</option>
							<option value="Singapore">Singapore</option>
							<option value="Slovakia">Slovakia</option>
							<option value="Slovenia">Slovenia</option>
							<option value="Solomon Islands">Solomon Islands</option>
							<option value="Somalia">Somalia</option>
							<option value="South Africa">South Africa</option>
							<option value="South korea">South korea</option>
							<option value="South Georgia and The South Sandwich Islands"
								>South Georgia and The South Sandwich Islands</option
							>
							<option value="Spain">Spain</option>
							<option value="Sri Lanka">Sri Lanka</option>
							<option value="Sudan">Sudan</option>
							<option value="Suriname">Suriname</option>
							<option value="Svalbard and Jan Mayen"
								>Svalbard and Jan Mayen</option
							>
							<option value="Swaziland">Swaziland</option>
							<option value="Sweden">Sweden</option>
							<option value="Switzerland">Switzerland</option>
							<option value="Syrian Arab Republic">Syrian Arab Republic</option>
							<option value="Taiwan, Province of China"
								>Taiwan, Province of China</option
							>
							<option value="Tajikistan">Tajikistan</option>
							<option value="Tanzania, United Republic of"
								>Tanzania, United Republic of</option
							>
							<option value="Thailand">Thailand</option>
							<option value="Timor-leste">Timor-leste</option>
							<option value="Togo">Togo</option>
							<option value="Tokelau">Tokelau</option>
							<option value="Tonga">Tonga</option>
							<option value="Trinidad and Tobago">Trinidad and Tobago</option>
							<option value="Tunisia">Tunisia</option>
							<option value="Turkey">Turkey</option>
							<option value="Turkmenistan">Turkmenistan</option>
							<option value="Turks and Caicos Islands"
								>Turks and Caicos Islands</option
							>
							<option value="Tuvalu">Tuvalu</option>
							<option value="Uganda">Uganda</option>
							<option value="Ukraine">Ukraine</option>
							<option value="United Arab Emirates">United Arab Emirates</option>
							<option value="United Kingdom">United Kingdom</option>
							<option value="United States">United States</option>
							<option value="United States Minor Outlying Islands"
								>United States Minor Outlying Islands</option
							>
							<option value="Uruguay">Uruguay</option>
							<option value="Uzbekistan">Uzbekistan</option>
							<option value="Vanuatu">Vanuatu</option>
							<option value="Venezuela">Venezuela</option>
							<option value="Viet Nam">Viet Nam</option>
							<option value="Virgin Islands, British"
								>Virgin Islands, British</option
							>
							<option value="Virgin Islands, U.S.">Virgin Islands, U.S.</option>
							<option value="Wallis and Futuna">Wallis and Futuna</option>
							<option value="Western Sahara">Western Sahara</option>
							<option value="Yemen">Yemen</option>
							<option value="Zambia">Zambia</option>
							<option value="Zimbabwe">Zimbabwe</option>
						</select>
						<br />
						<input
							type="text"
							v-model="skills"
							placeholder="Enter Your skills (separate them by comma)"
							class="form-control skills"
							name="skills"
						/>
						<br />
						<!--  -->
						<!--  -->
						<!--  -->
						<!--  -->
						<!--  -->
						<!--  -->
						<!--  -->
						<!--  -->
						<!--  -->
						<select
							v-model="motherLanguage"
							name="motherLanguage"
							class="form-control motherLanguage"
						>
							<option value="Select Your Mother language" disabled
								>Select Your Mother language</option
							>
							<option value="En">English</option>
							<option value="Fr">French</option>
							<option value="It">Italian</option>
							<option value="Es">Spanish</option>
							<option value="Pr">Portuguez</option>
							<option value="Da">Dautch</option>
							<option value="Ar">Arabic</option>
						</select>
						<select
							v-model="secondLanguage"
							name="secondLanguage"
							class="form-control secondLanguage"
						>
							<option value="Select Your Second language (Optional)" disabled
								>Select Your Second language (Optional)</option
							>
							<option value="En">English</option>
							<option value="Fr">French</option>
							<option value="It">Italian</option>
							<option value="Es">Spanish</option>
							<option value="Pr">Portuguez</option>
							<option value="Da">Dautch</option>
							<option value="Ar">Arabic</option>
						</select>
						<select
							v-model="thirdLanguage"
							name="thirdLanguage"
							class="form-control thirdLanguage"
						>
							<option value="Select Your Third language (Optional)" disabled
								>Select Your Third language (Optional)</option
							>
							<option value="En">English</option>
							<option value="Fr">French</option>
							<option value="It">Italian</option>
							<option value="Es">Spanish</option>
							<option value="Pr">Portuguez</option>
							<option value="Da">Dautch</option>
							<option value="Ar">Arabic</option>
						</select>
						<br />
						<input
							type="password"
							v-model="password"
							placeholder="Enter Your Password"
							class="form-control password"
							name="password"
						/><br />
						<input
							type="password"
							v-model="password2"
							placeholder="Confirm Your password"
							class="form-control password2"
							name="password"
						/>
						<br />
					</div>
				</div>
				<br />
				<button
					@click="register()"
					disabled
					class="form-control register primary text-white btn"
				>
					Register
				</button>
				<br />
				<p class="suggestion">already have an account?</p>
				<router-link id="rl" to="/login"
					><p class="link text-primary">log in</p></router-link
				>
			</div>
			<!-- Background Image Owner Account -->
			<!-- <p class="text-white owner-credit text-right">
				Photo by <a href="https://unsplash.com/@owencavlys">Owen Lystrup</a> on
				<a href="https://unsplash.com/">Unsplash</a>
			</p>
		-->
		</div>
		<div class="footerApp">
			<footerApp></footerApp>
		</div>
	</div>
</template>

<script>
// IMPORT LINKS FILE
const link = require("../.././api.links.config.js");
import footerApp from "../components/footer.vue";

export default {
	name: "register",
	components: {
		footerApp,
	},

	data() {
		return {
			token: window.localStorage.getItem("access-token") || false, // TOKEN
			phoneREGEX: /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/,
			zipCodeREGEX: /^[0-9]{5}(?:-[0-9]{4})?$/,
			name: null,
			email: null,
			phone: null,
			address: null,
			zipCode: null,
			city: null,
			country: "Select your country",
			skills: null,
			motherLanguage: "Select Your Mother language",
			secondLanguage: "Select Your Second language (Optional)",
			thirdLanguage: "Select Your Third language (Optional)",
			password: null,
			password2: null,
			err: null,
		};
	},
	created() {
		// SET SCROLL LEVEL TO 0 WHICH MEANS TO THE TOP
		window.scrollTo(0, 0);
		// auth stuff goes here...
		if (this.token) {
			this.$router.push("/");
		}
	},
	methods: {
		register: function() {
			// CHECK THE SECOND AND THIRD LANGUAGES IF PROVIDED
			if (this.secondLanguage === "Select Your Second language (Optional)") {
				this.secondLanguage = null;
			} 
			if (this.thirdLanguage === "Select Your Third language (Optional)") {
				this.thirdLanguage = null;
			}
			// COLLECT DATA
			const body = {
				name: this.name,
				email: this.email,
				phone: this.phone,
				address: this.address,
				zipCode: this.zipCode,
				city: this.city,
				country: this.country,
				skills: this.skills,
				languages: {
					motherLanguage: this.motherLanguage,
					secondLanguage: this.secondLanguage,
					thirdLanguage: this.thirdLanguage,
				},
				password: this.password,
				password2: this.password2,
				// languages ...
			};

			// CHANGE BTN CONTENT
			document.querySelector(
				".register"
			).innerHTML = `<span class="spinner-grow spinner-grow-sm text-dark" role="status" aria-hidden="true"></span>
			Please Wait...`;
			//REQUEST THE SERVER
			this.$http({
				method: "post",
				url: link.baselink + "/auth/register/",
				// withCredentials: true,
				data: body,
			})
				.then((res) => {
					// console.log(res.data)
					// CHECK USER IF LOGGED IN
					if (res.data.registered === true) {
						// STORE TOKEN IN THE LOCAL STORAGE
						window.localStorage.setItem("access-token", res.data.token);
						// RELOAD TO UPDATE HEADER
						window.location.reload();
						//REDIRECT THE USER TO THE DASHBOARD
						// this.$router.push('/dashboard')
					} else if (res.data.registered === false) {
						// alert(res.data.Message)
						// CHANGE BTN CONTENT
						document.querySelector(".register").innerHTML = "Register";
						// PUT ERR MESSAGE TO THE GLOBAL VARIABLE
						this.err = res.data.Message;
						// DISPLAY ERR MESSAGE
						document.querySelector(".errMsg").classList.remove("none");
						document.querySelector(".errMsg").classList.add("block");
						// FILL LANGUAGES FIELDS WITH DEFAULT VALUE
						if (this.secondLanguage == null) {
							this.secondLanguage = "Select Your Second language (Optional)";
						} 
						if (this.thirdLanguage == null) {
							this.thirdLanguage = "Select Your Third language (Optional)";
						}
						// INVISIBLE ERR MESSAGE AFTER 5S
						window.setTimeout(() => {
							document.querySelector(".errMsg").classList.remove("block");
							document.querySelector(".errMsg").classList.add("none");
						}, 5000);
					}
				})
				.catch((err) => {
					// Something goes here...
					// console.log(err);
					alert(err.message);
				});
		},
	},
	watch: {
		// VALIDATION STUFF
		name: function(name) {
			if (name.length > 15) {
				document.querySelector(".name").style.border = ".5px solid red";
			} else {
				document.querySelector(".name").style.border = "";
			}
		}, /////////////////
		email: function(email) {
			if (email.length < 10 && !email.includes("@") && !email.includes(".")) {
				document.querySelector(".email").style.border = ".5px solid red";
			} else {
				document.querySelector(".email").style.border = "";
			}
		}, /////////////////
		phone: function(phone) {
			if (!phone.match(this.phoneREGEX)) {
				document.querySelector(".phone").style.border = ".5px solid red";
			} else {
				document.querySelector(".phone").style.border = "";
			}
		}, /////////////////
		zipCode: function(zipCode) {
			if (zipCode.length > 5 && typeof zipCode !== "number") {
				document.querySelector(".zipCode").style.border = ".5px solid red";
			} else {
				document.querySelector(".zipCode").style.border = "";
			}
		}, /////////////////
		motherLanguage: function(motherLanguage) {
			if (motherLanguage === "Select Your Mother language") {
				document.querySelector(".motherLanguage").style.border =
					".5px solid red";
			} else {
				document.querySelector(".motherLanguage").style.border = "";
			}
		},
		/////////////////
		password2: function(password2) {
			if (password2.length < 7 && password2 !== this.password) {
				document.querySelector(".password2").style.border = ".5px solid red";
			} else {
				document.querySelector(".password2").style.border = "";

				if (
					this.name.length < 15 &&
					this.email.includes("@") &&
					this.email.includes(".") &&
					this.phone.match(this.phoneREGEX) &&
					this.zipCode.length < 6 &&
					this.motherLanguage !=
						"Select Your Mother language" && 
					this.password.length > 7 &&
					password2.length > 7
				) {
					// DISPLAY REGISTER BUTTON AFTER VALIDATE DATA
					document.querySelector(".register").removeAttribute("disabled");
				} else {
					// DISPLAY REGISTER BUTTON AFTER VALIDATE DATA
					document.querySelector(".register").setAttribute("disabled");
					// alert('hello world')
				}
			}
		},
	},
};
</script>

<style lang="css" scoped>
.title {
	color: var(--bg-color);
}
.background {
	/*background-image: url('.././assets/atul-vinayak-hZioHCEWSAE-unsplash.jpg'); /*Photo by Atul Vinayak on Unsplash  Mt Fuji */
	/*background-image: url('.././assets/chuttersnap-C4Lrq1F3vDQ-unsplash.jpg'); /*Photo by chuttersnap on Unsplash koalalampur city*/
	/*background-image: url(".././assets/owen-lystrup-boLgiM0qwkg-unsplash.jpg"); /*Photo by Owen Lystrup on Unsplash city in us */
	background-attachment: ;
	background-size: cover;
	background-repeat: no-repeat;
	background-position: center;
	height: 100%;
}
.owner-credit {
	/*margin-top:12%;*/
}
.registerComponent {
	border-radius: 3px;
	width: 60%;
	margin: 0 auto;
	background-color: white;
	position: relative;
	top: 30%;
	opacity: 0.9;
	transition: all 0.2s ease-out;
}
/*.registerComponent:hover {
		opacity: .9;
}
*/
.suggestion {
	color: var(--bg-color);
	font-weight: 100;
	font-size: 12px;
	display: inline;
	padding: 3px;
}
.link {
	font-weight: 100;
	font-size: 12px;
	display: inline;
	padding: 3px;
}
.red {
	background-color: var(--dan-ger);
}
.primary {
	background-color: var(--primary-color);
}
input {
	font-size: 13px;
}
.alert-message {
	height: 40px;
	font-weight: 100;
}
.red {
	background-color: var(--danger);
}
.primary {
	background-color: var(--primary-color);
}
.none {
	display: none;
}
.block {
	display: block;
}
.footerApp {
	margin-top: 100px;
}
@media only screen and (max-width: 600px) {
	.registerComponent {
		width: 100%;
	}
	.title {
		font-size: 30px !important;
	}
}
</style>
